import type { IconSvgObject } from './types';

const ChartIncreaseIcon: IconSvgObject = [
  ["path", { d: "M21 21H3V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 8L17.5 6L15 8M17.5 6C17.5 15.5 11 17 7 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartIncreaseIcon;
